import React, { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Spinner, Center } from '@chakra-ui/react';
import { getCurrentUser } from '../store/slices/authSlice';

/**
 * Компонент для захисту приватних маршрутів
 * Перевіряє чи користувач авторизований
 */
const ProtectedRoute = ({ children, requiredRole }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const sessionChecked = useRef(false);

  const { isAuthenticated, user, loading } = useSelector((state) => state.auth);

  /**
   * Перевірка сесії при завантаженні компонента
   * P3-001: токен у httpOnly cookie — перевіряємо через GET /api/auth/me
   */
  useEffect(() => {
    if (!sessionChecked.current && !user && !loading) {
      sessionChecked.current = true;
      dispatch(getCurrentUser());
    }
  }, [user, loading, dispatch]);

  // Показуємо spinner під час першої перевірки сесії
  if (loading || (!sessionChecked.current && !isAuthenticated)) {
    return (
      <Center h="100vh">
        <Spinner size="xl" color="blue.500" thickness="4px" />
      </Center>
    );
  }

  // Якщо не авторизований - редірект на логін
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Перевірка ролі (якщо вказана)
  if (requiredRole && user?.role !== requiredRole) {
    // Якщо не має потрібної ролі - редірект на головну
    return <Navigate to="/" replace />;
  }

  // Якщо все ок - показуємо контент
  return <>{children}</>;
};

/**
 * Компонент для захисту маршрутів тільки для адміністраторів
 */
export const AdminRoute = ({ children }) => {
  return (
    <ProtectedRoute requiredRole="admin">
      {children}
    </ProtectedRoute>
  );
};

export default ProtectedRoute;
